import React from 'react';
import ReactDOM from 'react-dom/client';
import ApplyOnlineApp from './ApplyOnlineApp';

const ELEMENT_ID = 'scl-apply-online-form';

class SCLApplyOnlineFormElement extends HTMLElement {
  constructor() {
    super();
    this.root = null;
  }

  connectedCallback() {
    // Prevent double initialization
    if (this.root) return;
    
    this.root = ReactDOM.createRoot(this);
    this.root.render(
      <ApplyOnlineApp/>
    );
  }

  disconnectedCallback() {
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
  }
}

if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, SCLApplyOnlineFormElement);
}

export default SCLApplyOnlineFormElement;
